import { render, staticRenderFns } from "./mainbox.vue?vue&type=template&id=ce70b8a6&scoped=true&"
import script from "./mainbox.vue?vue&type=script&lang=js&"
export * from "./mainbox.vue?vue&type=script&lang=js&"
import style0 from "./mainbox.vue?vue&type=style&index=0&id=ce70b8a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce70b8a6",
  null
  
)

export default component.exports